module.exports = __webpack_public_path__ + "static/img/first-bet-characte-02.3d8cc8e.png";